module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('h1', {
    staticClass: "introduction-title"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/h.jpg"
    }
  }), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHS")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/h1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age iii")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secretariat winning his second race—by six lengths.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secretariat on the plane heading for Claiborne Farm on November 11, 1973. Worried by")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the engine’s roar, he grips the jacket of his groom, Edward “Shorty” Sweat, with his teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 17")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eddie appears to be chatting up the big red horse before his last race, at Woodbine Racetrack in Toronto.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 51")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eddie Sweat looking happy and relaxed at his home away from home—the backstretch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 87")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secretariat as a foal. He was bigger and more muscled than most.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 103")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secretariat nuzzles Eddie Sweat while Riva Ridge looks on.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 143")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ed Bogucki’s bronze was unveiled in Lexington, Kentucky, on July 17, 2004. The life-sized bronze depicts Secretariat, jockey Ron Turcotte, and groom Eddie Sweat just moments after the Derby win.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 187")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The brass plates on Secretariat’s old stall at Claiborne Farm near Paris, Kentucky.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 223")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The metal plate on the grave of Eddie Sweat near Holly Hill, South Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 249")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secretariat crosses the finish line at Woodbine on October 28, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 281")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eddie Sweat struggles with his emotions on the day he hands over Secretariat to his new")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("keepers at Claiborne Farm near Paris, Kentucky.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("age 311")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eddie Sweat eyes Secretariat while the horse eyes the photographer on the grass behind the")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("track.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698ac5f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 78
// module chunks = 0